import styled from 'styled-components';

export const Container = styled.div`
  animation: rotating 2s linear infinite;
`;